/**
 * 类型趋势表格渲染子组件
 * 以表格形式展示趋势数据，支持维度名称翻译
 */
import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { DBO_V, DBO_EC } from '@op/utils/format';
import useLanguage from '@op/hooks/useLanguage';
import type { ITypeTrendTableProps } from './types';

const TypeTrendTable: React.FC<ITypeTrendTableProps> = ({
  chartData,
  dimensionMap,
  height,
  filter
}) => {
  // ==================== 多语言 ====================
  const { isEn, formatMessage } = useLanguage();

  // ==================== 维度名称翻译 ====================
  const getDimensionName = (key: string) => {
    const dimension = dimensionMap[key];
    if (!dimension) return key;
    return isEn ? dimension.en : dimension.zh;
  };

  // ==================== 表格数据 ====================
  const tableData = useMemo(() => {
    if (chartData?.isEmpty) return [];

    return chartData.tableRecord;
  }, [chartData]);

  // ==================== 表格列定义 ====================
  const columns = useMemo(() => {
    const cols: any[] = [
      {
        key: 'time',
        header: formatMessage('Date'),
        render: (value: { time: string; }) => DBO_EC.toolTime(value?.time, filter?.date_type || 'daily'),
        width: filter?.date_type === 'weekly' ? 220 : 160,
      },
    ];

    if (chartData?.legend) {
      chartData.legend.forEach((name: string) => {
        cols.push({
          key: name,
          header: getDimensionName(name),
          align: 'right',
          render: (value: any) => DBO_V.reviews(value?.[name] ?? 0),
        });
      });
    }

    return cols;
  }, [chartData, dimensionMap, formatMessage, isEn]);

  return (
    <div className="dbo-type-trend-table">
      <TableCommonHook
        columns={columns}
        records={tableData}
        hasPageable={false}
        maxHeight={height - 49.5}
        minWidth={"auto"}
      />
    </div>
  );
};

export default React.memo(TypeTrendTable);
